import addCustomSearchProps from './addCustomSearchProps'

const addGenericFilters = (coluna) => {
  const { dataIndex } = coluna
  let result = { ...coluna }

  if (coluna.searchable === true) {
    result = {
      ...result,
      ...addCustomSearchProps(dataIndex)
    }
  }

  if (coluna.sortAsNumber === true) {
    result = {
      ...result,
      sorter: (a, b) => {
        if (Number.isNaN(a) || Number.isNaN(b)) {
          return -1
        }

        const aNumber = Number(a[dataIndex])
        const bNumber = Number(b[dataIndex])

        return aNumber - bNumber > 0 ? 1 : -1
      }
    }
  }

  if (coluna.sortAsText === true) {
    result = {
      ...result,
      sorter: (a, b) => {
        if (
          typeof a[dataIndex] !== 'string' ||
          typeof b[dataIndex] !== 'string'
        ) {
          return -1
        }

        return a[dataIndex].toLowerCase() < b[dataIndex].toLowerCase() ? -1 : 1
      }
    }
  }

  return result
}

export default addGenericFilters
